import {
  Button,
} from "@material-tailwind/react";
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';

import { IoIosArrowDown } from "react-icons/io";
import { useEffect, useState } from "react";
import { ComplaintID } from "../services/complaintServices";
import { formatDateTime } from "../utils/FormateDate";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { RiFileCopyFill } from "react-icons/ri";
import { CompliantStatusEnum } from "../utils/Enums";

const OpenComplainDrawer = ({ isOpen, onClose, id}) => {
  const [complaints, setComplaints] = useState(null);
  const [loading, setLoading] = useState(false);
  const [textToCopy, setTextToCopy] = useState(false);
  const phoneNumber = complaints?.customerPhoneNumber

  const onCopyText = () => {
    setTextToCopy(true);
    toast.success("Copied!")
    setTimeout(() => setTextToCopy(false), 2000); 
  };

    useEffect(() => {
        const fetchComplaint = async () => {
            setLoading(true)
            if (id){
              try {
              const response = await ComplaintID(id);
              setComplaints(response?.data);
              } catch (error) {
              console.error("Error fetching order details:", error);
              toast.error("Failed to load order details.");
              } finally {
              setLoading(false);
              }
            } else {
              return null
            }
        }
        fetchComplaint();
    }, [id]);
 
  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}
    slotProps={{
      root: {
        className: `
          backdrop-blur-[1px] 
          bg-orange/20 
          rounded-tl-2xl 
        `,
      },
    }}  
    >
      <ModalClose />
      <div className="p-5">
        <h2 className="capitalize text-[24px] font-bold text-primaryRed mt-5">Review Overview</h2>

        <p className="mb-6 mt-4 text-sm text-[#0A0A0ACC]">
          Get a complete view of customer feedback to understand experiences better and take actions that enhance service quality.  </p>
          <div className="mt-1 space-y-4">
            <div className="grid place-items-end">
              <p className={`text-xs p-2 text-white flex items-center rounded-md
                ${
                  CompliantStatusEnum[complaints?.status] === 'Resolved'
                  ? 'bg-[#008000] text-white'
                  : CompliantStatusEnum[complaints?.status] === 'In Progress'
                  ? 'bg-orange text-black'
                  : CompliantStatusEnum[complaints?.status] === 'Open'
                  ? 'bg-[#4A90E2] text-white'
                  : "bg-primaryGray text-black"
                  }
                `}>
                <span>
                  {CompliantStatusEnum[complaints?.status]}
                </span>
              <IoIosArrowDown className="text-white ml-1" />
              </p>
            </div>
              {complaints && 
                (
                  <div>
                    <div className="rounded-lg border px-3">
                      <div className="flex justify-between items-center mt-2">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Complanit ID</p>
                        <p className="text-xs font-medium">{complaints?.code}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className="flex justify-between items-center mt-3">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Customer Name</p>
                        <p className="text-xs font-medium">{complaints?.customerFirstName} {complaints?.customeLastName}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className="flex justify-between items-center mt-3">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Customer Number</p>
                        <div className='flex items-center my-1'>
                          <p className="text-xs font-medium">{phoneNumber}</p>
                          <CopyToClipboard text={phoneNumber} onCopy={onCopyText}>
                            <RiFileCopyFill class="text-gray-400 ml-1 cursor-pointer" />
                          </CopyToClipboard>
                        </div>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className="flex justify-between items-center mt-3">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Agent Name</p>
                        <p className="text-xs font-medium">Adekoya Omoshalewa</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className="flex justify-between items-center mt-3">
                        <p className="text-xs text-[#0A0A0A] opacity-80 capitalize">date of submission</p>
                          <p className="text-xs font-medium">{formatDateTime(complaints?.dateCreated)}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className='flex items-center mt-3 justify-between'>
                        <p className="text-xs text-[#0A0A0A] opacity-80">Email</p>
                        <p className="text-xs font-medium">{complaints?.customerEmail}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                    </div>
                    <div className="my-4 rounded-lg border bg-white shadow-md pb-1">
                      <div className="flex justify-between items-center py-1 px-2 mt-2 rounded-tl-md rounded-tr-md">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Complaint submitted.</p>
                        <p className="text-xs font-medium">{formatDateTime(complaints?.dateCreated)}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className="flex justify-between items-center mt-[1px] py-1 px-2">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Assigned to support .</p>
                        <p className="text-xs font-medium">{formatDateTime(complaints?.dateCreated)}</p>
                      </div>
                    </div>
                    <div className="my-2 rounded-lg mb-1">
                      <div>
                        <p className="text-xs font-semibold mb-2">Complaints</p>
                        <div className={`p-2 rounded-md mt-2 shadow-md text-white
                          ${
                            CompliantStatusEnum[complaints?.status] === 'Resolved'
                            ? 'bg-[#008000] text-white'
                            : CompliantStatusEnum[complaints?.status] === 'In Progress'
                            ? 'bg-orange text-black'
                            : CompliantStatusEnum[complaints?.status] === 'Open'
                            ? 'bg-[#4A90E2] text-white'
                            : "bg-primaryGray text-black"
                            }
                        `}>
                          <p className="text-xs">{complaints?.issue}</p>
                        </div>
                        </div>
                      </div>
                    </div>
                )}    
            <label className="text-sm pt-3">Enter Response</label>
            <div className="my-1">
              <input className="border-2 border-[#00000] border-opacity-30 rounded-md px-4 w-full py-1.5 outline-none ring-0 text-xs" type="text" placeholder="Give a reply to complaints" />
            </div>
            <Button isFullWidth
              className="bg-[#FF0000] hover:bg-opacity-30 text-white outline-none ring-0 border-0 hover:bg-red-300 capitalize mt-1"
            >Respond To Review </Button>
          </div>
        </div>
    </Drawer>
  );
}

export default OpenComplainDrawer;